import {
  createRequestTypes,
  createActions,
} from 'app/store/actions/base-request.actions'

export const EBOOKS_ACTIONS = createRequestTypes('[Media] EBOOKS')
export const BIBLIOTECA_ACTIONS = createRequestTypes('[Media] BIBLIOTECA')
export const CAMINOS_ACTIONS = createRequestTypes('[Media] CAMINOS')
export const TEXAS_ELAR_ACTIONS = createRequestTypes('[Media] TEXAS ELAR')
export const TEXAS_SLAR_ACTIONS = createRequestTypes('[Media] TEXAS SLAR')

export const ebooksActionCreators = createActions(EBOOKS_ACTIONS)
export const bibliotecaActionCreators = createActions(BIBLIOTECA_ACTIONS)
export const caminosActionCreators = createActions(CAMINOS_ACTIONS)
export const texasElarActionCreators = createActions(TEXAS_ELAR_ACTIONS)
export const texasSlarActionCreators = createActions(TEXAS_SLAR_ACTIONS)
